import { render, staticRenderFns } from "./Regstock.vue?vue&type=template&id=04034302&scoped=true"
import script from "./Regstock.vue?vue&type=script&lang=js"
export * from "./Regstock.vue?vue&type=script&lang=js"
import style0 from "./Regstock.vue?vue&type=style&index=0&id=04034302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04034302",
  null
  
)

export default component.exports